import axios from "axios";
import {CreateNote, Note} from "./noteSlice";

export const createNote = async (
    data: CreateNote,
    apiToken: string) => {

    const headers = {
        Authorization: `Bearer ${apiToken}`
    };

    return await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/notes`, data, {
            headers: headers
        });
};

export const saveNote = async (
    data: Note,
    apiToken: string) => {

    const headers = {
        Authorization: `Bearer ${apiToken}`,
    };

    return await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/notes/${data.id}`, data, {
            headers: headers
        });
};

export const findTagsLikeName = async (
    apiToken: string,
    name: string) => {
    return await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/notes/tags?name=${name}`, {
            headers: {
                Authorization: `Bearer ${apiToken}`,
            }
        });
};

export const getNotes = async (apiToken: string, skip: number, top: number) => {
    return await axios.get(
        `${process.env.REACT_APP_ODATA_API_BASE_URL}/notes?$filter=archived eq false&$select=id,subject,archived,created,lastModified & $orderby=lastModified desc&skip=${skip}&top=${top}&count=true`, {
            headers: {
                Authorization: `Bearer ${apiToken}`,
            }
        });
};

export const getNoteById = async (apiToken: string, id: string) => {
    return await axios.get(
        `${process.env.REACT_APP_ODATA_API_BASE_URL}/notes/?$expand=tags&$expand=customers&$filter=id eq ${id}`, {
            headers: {
                Authorization: `Bearer ${apiToken}`,
            }
        });
};  

export const deleteNoteFile = async (
    apiToken: string, 
    noteId: string, 
    noteFileId: string) => {
    return await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/notes/${noteId}/files/${noteFileId}`, {
            headers: {
                Authorization: `Bearer ${apiToken}`,
            }
        });
};

export const filterNotes = async (
    apiToken: string,
    filter: string,
    skip: number,
    top: number) => {
    const selectClause = 'notes?$select=id,subject,archived,created,lastModified'; 
    
    return await axios.get(
        `${process.env.REACT_APP_ODATA_API_BASE_URL}/${selectClause}${filter}&skip=${skip}&top=${top}&count=true`, {
            headers: {
                Authorization: `Bearer ${apiToken}`,
            }
        });
};

export const getNoteFilesById = async (apiToken: string, id: string) => {
    return await axios.get(
        `${process.env.REACT_APP_ODATA_API_BASE_URL}/notes?$expand=files&$filter=id eq ${id}&select=files`, {
            headers: {
                Authorization: `Bearer ${apiToken}`,
            }
        });
};
